/**
 * pendingTour.js — tiny handoff for launching a tour after navigation.
 *
 * The release popup lives on the management view, but tours target elements
 * inside an editor. So "Start tour" sets a pending tour key here, opens the
 * matching editor, and the editor picks the key up on mount (see
 * useAutoStartTour) and runs it. Module-level state; no persistence needed.
 */

let pending = null;

export const setPendingTour = (key) => {
  pending = key;
};

export const peekPendingTour = () => pending;

export const clearPendingTour = () => {
  pending = null;
};

// Map a form type to the tour that teaches it.
export const TOUR_FOR_TYPE = {
  item: 'standard-form',
  subitem: 'standard-form',
  action: 'action-form',
  nps: 'survey-form',
};
